// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import React from "react";

const IconAngleUp = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="10" viewBox="0 0 15 10">
            <path
                fill="currentColor"
                d="M7.4998045,8.75 C7.17996061,8.75 6.85996056,8.62792969 6.61621094,8.38378906 L0.366210938,2.13378906 C-0.122070313,1.64550781 -0.122070313,0.854492188 0.366210938,0.366210938 C0.854492188,-0.122070312 1.64550781,-0.122070312 2.13378906,0.366210938 L7.4998045,5.73437452 L12.8669918,0.367187262 C13.355273,-0.121093988 14.1462886,-0.121093988 14.6345699,0.367187262 C15.1228511,0.855468512 15.1228511,1.64648414 14.6345699,2.13476539 L8.38456988,8.38476539 C8.14042926,8.62890601 7.82011688,8.75 7.4998045,8.75 Z"
                transform="translate(0 .75)"
            />
        </svg>
    );
};

export default React.memo(IconAngleUp);
